export function formatToShortHand(number) {
    return `${Math.trunc(number).toLocaleString()}`
}